var _path, _line, _path2, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTasteGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 138,
    viewBox: "0 0 226 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176 0.5C189.722 0.5 202.122 4.22754 211.077 10.2275C220.036 16.2297 225.5 24.4673 225.5 33.5C225.5 42.5327 220.036 50.7703 211.077 56.7725C202.122 62.7725 189.722 66.5 176 66.5C162.278 66.5 149.878 62.7725 140.923 56.7725C131.964 50.7703 126.5 42.5327 126.5 33.5C126.5 24.4673 131.964 16.2297 140.923 10.2275C149.878 4.22754 162.278 0.5 176 0.5Z",
    fill: "white",
    stroke: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 146.367,
    y1: 54.3391,
    x2: 134.367,
    y2: 67.3391,
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.073 25.784H174.353V40.248H173.073V25.784ZM167.073 31.304H170.705V32.392H167.073V31.304ZM170.161 26.12H171.425V39.512H170.161V26.12ZM162.609 35.656H163.537C165.793 35.656 167.153 35.592 168.753 35.256L168.881 36.36C167.233 36.712 165.841 36.776 163.537 36.776H162.609V35.656ZM162.609 27.544H168.049V28.632H163.921V36.088H162.609V27.544ZM187.712 25.784H188.976V35.944H187.712V25.784ZM183.488 30.264H185.68V31.352H183.488V30.264ZM185.072 26.008H186.336V34.84H185.072V26.008ZM176.72 27.576H183.888V28.632H176.72V27.576ZM180.288 29.368C182.048 29.368 183.296 30.424 183.296 31.992C183.296 33.576 182.048 34.632 180.288 34.632C178.544 34.632 177.296 33.576 177.296 31.992C177.296 30.424 178.544 29.368 180.288 29.368ZM180.288 30.392C179.216 30.392 178.48 31.032 178.48 31.992C178.48 32.952 179.216 33.608 180.288 33.608C181.392 33.608 182.112 32.952 182.112 31.992C182.112 31.032 181.392 30.392 180.288 30.392ZM179.632 25.912H180.96V28.296H179.632V25.912ZM183.52 35.336H184.64V35.688C184.64 38.12 181.984 39.768 179.024 40.2L178.56 39.16C181.136 38.84 183.52 37.432 183.52 35.688V35.336ZM183.696 35.336H184.832V35.688C184.832 37.432 187.216 38.84 189.792 39.16L189.328 40.2C186.368 39.768 183.696 38.12 183.696 35.688V35.336Z",
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4159_27074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.66 69.6201H89.5601V75.3201H100.66V69.6201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.45 63.9099H100.46V80.8999H113.45V63.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38 52.8201H94.6802V58.3301H105.38V52.8201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.44 80.9099H106.2V86.5599H113.44V80.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.56 69.6201H111.69V115.03H117.56V69.6201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.56 114.53H106.2V120.75H117.56V114.53Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.57 120.47H100.39V126.22H117.57V120.47Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.56 125.98H95.1499V131.73H117.56V125.98Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6101 52.8201H62.1001V58.3301H72.6101V52.8201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3601 63.9099H54.0801V69.6099H67.3601V63.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.3498 69.6201H50.3198V80.9101H67.3498V69.6201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9698 86.5901H50.3198V92.2401H55.9698V86.5901Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5498 80.9099H50.3198V86.5999H61.5498V80.9099Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2001 69.6201H78.3101V75.3201H84.2001V69.6201Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66 75.3201H67.3599V80.9101H100.66V75.3201Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 80.9099H61.5498V88.6699H106.2V80.9099Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.69 86.5901H55.9399V114.53H111.69V86.5901Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3798 92.24H50.3198V115.02H56.3798V92.24Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.2 113.69H55.71V120.75H106.2V113.69Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.39 120.08H61.5498V126.22H100.39V120.08Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.16 125.98H67V131.73H95.16V125.98Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7098 115.02H50.3198V131.73H55.7098V115.02Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.55 120.75H55.71V131.74H61.55V120.75Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.99 126.22H61.48V131.73H66.99V126.22Z",
    fill: "#009344"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.38 47H62.1001V52.82H105.38V47Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.76 69.6201H117.56V131.74H122.76V69.6201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.56 131.74H50.3198V137.48H117.56V131.74Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.32 69.6201H45V131.74H50.32V69.6201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3602 63.9099H48.6602V69.6099H54.3602V63.9099Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6102 58.3201H52.4702V63.9101H58.6102V58.3201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1098 52.8201H56.5498V58.3301H62.1098V52.8201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.89 52.8201H105.38V58.3301H110.89V52.8201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.99 58.3201H109.4V63.9101H114.99V58.3201Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.15 63.9099H113.45V69.6099H119.15V63.9099Z",
    fill: "#006737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.8502 69.6201H84.2002V75.2701H89.8502V69.6201Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3099 69.6201H67.3599V75.3201H78.3099V69.6201Z",
    fill: "#FAF0D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6799 52.8201H72.6099V58.3301H94.6799V52.8201Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.4 58.3201H58.6099V63.9101H109.4V58.3201Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.66 63.9099H67.3599V69.6099H100.66V63.9099Z",
    fill: "#8CC63F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4401 91.77H63.8901V93.94H68.4401V91.77Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4401 91.53H63.8901V91.78H68.4401V91.53Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8801 91.53H63.6401V93.94H63.8801V91.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6799 91.77H68.4399V93.94H68.6799V91.77Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6799 91.53H68.4399V91.77H68.6799V91.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8799 91.53H63.6299V91.78H63.8799V91.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6301 91.78H71.0801V93.95H75.6301V91.78Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6301 91.53H71.0801V91.78H75.6301V91.53Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0598 91.54H70.8198V93.95H71.0598V91.54Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8601 91.78H75.6201V93.92H75.8601V91.78Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8801 91.53H75.6201V91.78H75.8801V91.53Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8302 93.95H68.6802V96.31H70.8302V93.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.0299 93.95H75.8799V101.11H78.0299V93.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.63 93.95H61.48V101.11H63.63V93.95Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6402 101.11H73.4702V103.31H75.6402V101.11Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.24 103.53H71.04V105.73H73.24V103.53Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8399 105.91H68.6699V108.15H70.8399V105.91Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.46 103.53H66.29V105.73H68.46V103.53Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.0401 101.11H63.8701V103.31H66.0401V101.11Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8801 93.95H63.6401V103.53H63.8801V93.95Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.8801 93.95H75.6201V103.53H75.8801V93.95Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.2901 103.31H63.8701V103.53H66.2901V103.31Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.46 105.73H66.04V105.95H68.46V105.73Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.06 108.15H68.46V108.37H71.06V108.15Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2399 105.73H70.9399V105.95H73.2399V105.73Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67 105.91H68.46V108.15H68.67V105.91Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0401 105.84H70.8301V108.15H71.0401V105.84Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4697 101.11H73.2397V105.95H73.4697V101.11Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.6699 93.95H63.8799V101.11H68.6699V93.95Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8299 96.3201H68.6699V105.71H70.8299V96.3201Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2398 98.74H70.8198V103.53H73.2398V98.74Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6197 98.74H73.2397V101.11H75.6197V98.74Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.76 101.11H66.29V103.31H68.76V101.11Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2401 96.3201H71.0801V98.7401H73.2401V96.3201Z",
    fill: "#C91C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.67 103.31H66.29V103.53H68.67V103.31Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0498 103.53H70.8198V105.91H71.0498V103.53Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8399 105.71H68.6699V105.93H70.8399V105.71Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.68 103.53H68.46V105.93H68.68V103.53Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0698 96.3201H70.8198V98.8501H71.0698V96.3201Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.0698 93.95H70.8198V96.32H71.0698V93.95Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2398 93.95H71.0698V96.32H73.2398V93.95Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6002 96.5701H73.4702V98.5001H75.6002V96.5701Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6202 93.95H73.4702V96.32H75.6202V93.95Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4697 93.95H73.2397V96.31H73.4697V93.95Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4697 96.3201H73.2397V98.7401H73.4697V96.3201Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6202 96.3201H73.4702V96.5701H75.6202V96.3201Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6202 98.5H73.4702V98.74H75.6202V98.5Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29 101.11H66.04V103.31H66.29V101.11Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.29 103.53H66.04V105.73H66.29V103.53Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.6402 103.31H73.4702V103.53H75.6402V103.31Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6799 91.8H90.1299V93.9701H94.6799V91.8Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6799 91.55H90.1299V91.8H94.6799V91.55Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1199 91.5601H89.8799V93.9701H90.1199V91.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9202 91.8H94.6802V93.9701H94.9202V91.8Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9202 91.5601H94.6802V91.8001H94.9202V91.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1299 91.55H89.8799V91.8H90.1299V91.55Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87 91.8H97.3198V93.9701H101.87V91.8Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87 91.55H97.3198V91.8H101.87V91.55Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3098 91.5601H97.0698V93.9701H97.3098V91.5601Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.11 91.8H101.87V93.94H102.11V91.8Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13 91.55H101.87V91.8H102.13V91.55Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0699 93.97H94.9199V96.33H97.0699V93.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.28 93.97H102.13V101.13H104.28V93.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.88 93.97H87.73V101.13H89.88V93.97Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89 101.13H99.7202V103.33H101.89V101.13Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.49 103.55H97.29V105.75H99.49V103.55Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0802 105.94H94.9102V108.18H97.0802V105.94Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71 103.55H92.54V105.75H94.71V103.55Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.2901 101.13H90.1201V103.33H92.2901V101.13Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.1199 93.97H89.8799V103.55H90.1199V93.97Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.13 93.97H101.87V103.55H102.13V93.97Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.5401 103.34H90.1201V103.56H92.5401V103.34Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.71 105.75H92.29V105.97H94.71V105.75Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.31 108.17H94.71V108.39H97.31V108.17Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4899 105.75H97.1899V105.97H99.4899V105.75Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.92 105.94H94.71V108.18H94.92V105.94Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2901 105.86H97.0801V108.17H97.2901V105.86Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7197 101.13H99.4897V105.97H99.7197V101.13Z",
    fill: "#70835B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.9199 93.97H90.1299V101.13H94.9199V93.97Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0702 96.3401H94.9102V105.73H97.0702V96.3401Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4898 98.76H97.0698V103.55H99.4898V98.76Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87 98.76H99.4897V101.13H101.87V98.76Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.01 101.13H92.54V103.33H95.01V101.13Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4798 96.3401H97.3198V98.7601H99.4798V96.3401Z",
    fill: "#C91C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.92 103.34H92.54V103.56H94.92V103.34Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.2998 103.55H97.0698V105.93H97.2998V103.55Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0802 105.73H94.9102V105.95H97.0802V105.73Z",
    fill: "#B14E65"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.93 103.55H94.71V105.95H94.93V103.55Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3198 96.3401H97.0698V98.8701H97.3198V96.3401Z",
    fill: "#D91862"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3198 93.97H97.0698V96.34H97.3198V93.97Z",
    fill: "#917886"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.4898 93.97H97.3198V96.34H99.4898V93.97Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.85 96.5901H99.7202V98.5201H101.85V96.5901Z",
    fill: "#F49EC4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87 93.97H99.7202V96.34H101.87V93.97Z",
    fill: "#FCEFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7197 93.97H99.4897V96.33H99.7197V93.97Z",
    fill: "#F9DBE9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7197 96.3401H99.4897V98.7601H99.7197V96.3401Z",
    fill: "#DC6F8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87 96.3401H99.7202V96.5901H101.87V96.3401Z",
    fill: "#F6B2D0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.87 98.52H99.7202V98.76H101.87V98.52Z",
    fill: "#EC83A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.54 101.13H92.29V103.33H92.54V101.13Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.54 103.55H92.29V105.75H92.54V103.55Z",
    fill: "#89565F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.89 103.34H99.7202V103.56H101.89V103.34Z",
    fill: "#555D50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.8802 107.04H74.4302V111.83H76.8802V107.04Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.0604 109.44H81.6704V111.83H84.0604V109.44Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0101 107.04H88.5601V111.83H91.0101V107.04Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.6704 111.83H76.8804V114.13H81.6704V111.83Z",
    fill: "#221E1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.5501 111.83H84.0601V114.13H88.5501V111.83Z",
    fill: "#221E1F"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 87,
    r: 6,
    fill: "url(#paint0_radial_4159_27074)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 120.5,
    r: 12.5,
    fill: "url(#paint1_radial_4159_27074)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 142.5,
    cy: 129.5,
    r: 5.5,
    fill: "url(#paint2_radial_4159_27074)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 100.5,
    r: 7.5,
    fill: "url(#paint3_radial_4159_27074)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 110,
    r: 9,
    fill: "url(#paint4_radial_4159_27074)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.5,
    cy: 96.5,
    r: 4.5,
    fill: "url(#paint5_radial_4159_27074)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_4159_27074",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.24 87.24) rotate(92.3859) scale(5.765)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#BBE67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBC5",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4159_27074",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13 121) rotate(92.3859) scale(12.0104)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#BBE67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBC5",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_4159_27074",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(142.72 129.72) rotate(92.3859) scale(5.28458)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#BBE67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBC5",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4159_27074",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.8 100.8) rotate(92.3859) scale(7.20625)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#BBE67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBC5",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_4159_27074",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(137.36 110.36) rotate(92.3859) scale(8.6475)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#BBE67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBC5",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4159_27074",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(150.68 96.68) rotate(92.3859) scale(4.32375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#BBE67C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5FBC5",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4159_27074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.76,
    height: 90.48,
    fill: "white",
    transform: "translate(45 47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTasteGreen);
export default __webpack_public_path__ + "static/media/Taste_Green.9ffa0ca409cd69bd44ecd7e03389fa16.svg";
export { ForwardRef as ReactComponent };